import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import "./topbar.css";
import { Notifications } from "@mui/icons-material";
import SocialContext from '../../context/SocialContext';
import HomeIcon from '@mui/icons-material/Home';
import GroupIcon from '@mui/icons-material/Group';
import { useContext, useEffect } from 'react';
import Dropdown from '../Dashboard/Dropdown';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import ChatIcon from '@mui/icons-material/Chat';
import { useLocation } from 'react-router-dom';

export default function Topbar() {
  const location = useLocation();
  const {countunreadnotification, user,fetchcurrentuserfun,unreadnotification } = useContext(SocialContext);
  
  const PF = "https://socialshub.netlify.app/images/";
  const [userid,setuserid]=useState(null);
  useEffect(() => {
    if(window.localStorage.getItem('currentUID')){
      countunreadnotification();
      setuserid(window.localStorage.getItem('currentUID'));
    }
    fetchcurrentuserfun();
  }, [])

  const scrolatTopfun = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  return (
    <div className="topbarContainer">
      <div className="topbarLeft">
        <Link style={{ 'textDecoration': 'none' }} onClick={scrolatTopfun} to='/'><span className="logo">SocialHub</span></Link>
      </div>
      <div className="topbarCenter">
        {window.localStorage.getItem('currentUID') ? <div className="topcenterIcon">
          <div className="iconBar">
            <Link style={{ 'textDecoration': 'none' }} to={'/'}><HomeIcon className="Icon" /></Link>
          </div>
          <div className="iconBar">
            <Link style={{ 'textDecoration': 'none' }} to={'/friends'}><GroupIcon className="Icon" /></Link>
          </div>
          <div className="iconBar">
            <Link style={{ 'textDecoration': 'none' }} to={'/messanger'}><ChatIcon className="Icon" /></Link>
          </div>
          <div className="iconBar">
            <Link to={'/share'}><AddCircleOutlineTwoToneIcon className="Icon" /></Link>
          </div>
          <div className="iconBar iconBarNotification">
            <Link to={`/notifications/${userid}`}><Notifications className="Icon" /></Link>
            {unreadnotification>0?<span>{unreadnotification}</span>:''}
          </div>
        </div> : ''}
      </div>
      <div className="topbarRight">
        {window.localStorage.getItem('currentUID') ? <Dropdown user={user} /> :
          <>
            <button className='LoginBtn'><Link style={{ color: 'white', 'textDecoration': 'none' }} to={'/login'}>LogIn</Link></button>
            <button className='LoginBtn'><Link style={{ color: 'white', 'textDecoration': 'none' }} to={'/register'}>SignUp</Link></button>
          </>
        }
      </div>
    </div>
  );
}